/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */

export const AuthView = {
  Login: "login",
  Register: "register",
} as const;

export type AuthView = (typeof AuthView)[keyof typeof AuthView];

export const MIN_PASSWORD_LENGTH = 12;

export const isValidEmail = (email: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

export const isPasswordLongEnough = (password: string): boolean =>
  password.length >= MIN_PASSWORD_LENGTH;
